import { ExtendedTariffEntityType } from "@/dentlab/src/store/Jobs/types";
import {
	ArticleEntityType,
	TariffEntityType,
} from "@/lib/supabase/supabaseTypes";
import { Typography } from "@mui/material";
import { FC } from "react";

export const ItemListing: FC<{
	rows: ExtendedTariffEntityType[] | TariffEntityType[] | ArticleEntityType[];
	jobItemCodes: { code_e: string }[];
	handleClick:
		| ((
				e: React.MouseEvent<HTMLDivElement>,
				row: TariffEntityType | ArticleEntityType
		  ) => void)
		| ((
				e: React.MouseEvent<HTMLDivElement>,
				row: ExtendedTariffEntityType
		  ) => void);
}> = ({ rows, jobItemCodes, handleClick }) => {
	return (
		<>
			{rows.map(
				(
					row:
						| TariffEntityType
						| ArticleEntityType
						| ExtendedTariffEntityType
				) => (
					<div
						key={row.id + row.code_e}
						data-testid="job-items-selection-list-item"
						className="list-item"
						style={{
							background: jobItemCodes.find(
								(j) => j.code_e === row.code_e
							)
								? "var(--neutral-light)"
								: "inherit",
						}}
						// @ts-expect-error row has many possible types
						onClick={(e) => handleClick(e, row)}
					>
						<Typography variant="subtitle2">
							{row.code_e}
						</Typography>
						<Typography variant="body2" noWrap>
							{row.description_de}
						</Typography>
						{
							// .custom property is added by mergePositions() but does not exist in the database
							(row as any).custom ? (
								<Typography
									variant="caption"
									sx={{
										border: "1px solid",
										borderRadius: "5px",
									}}
								>
									Eigener
								</Typography>
							) : null
						}
					</div>
				)
			)}
		</>
	);
};
